import Watch from './Watch'

export default Watch
// eslint-disable-next-line import/export
export * from './Watch'
